import { createPublicClient, defineChain, http, type PublicClient } from "viem";
import { chainNameForChainId } from "./coinbase/network";

/**
 * A read-only viem public client built from the server-provided `GET /config/public`
 * chain/RPC values (never a hardcoded address/URL — see Build.md). Used only for
 * best-effort balance display; all financial state comes from the API, never from a
 * client-side chain read.
 */
export function createReadClient(chainId: number, rpcUrl: string): PublicClient {
  const chain = defineChain({
    id: chainId,
    name: chainNameForChainId(chainId),
    nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
    rpcUrls: { default: { http: [rpcUrl] } },
  });
  return createPublicClient({ chain, transport: http(rpcUrl) });
}
